import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

import { slideContentInset } from "../../SideCarouselPanel.styles";

export const contentMaxWidth = "415px";
export const contentMaxWidthWidescreen = "640px";

export const slide = (theme: Theme, backgroundColor: string) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${slideContentInset(theme)};
  background-color: ${backgroundColor};
`;

export const content = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.xlarge};
  width: 100%;
  max-width: ${contentMaxWidth};

  @media (min-width: ${dimensions.widescreen}) {
    max-width: ${contentMaxWidthWidescreen};
  }
`;

export const banner = (theme: Theme) => css`
  width: 100%;
  aspect-ratio: 415 / 150;
  border-radius: ${theme.ds5.radius.background.medium};
  object-fit: cover;
`;

export const textStack = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.medium};
  max-width: 360px;
  text-align: center;

  @media (min-width: ${dimensions.widescreen}) {
    max-width: 480px;
  }
`;
